import n from "./_isPlaceholder.mjs";
function a(r) {
  return function e(t) {
    return arguments.length === 0 || n(t) ? e : r.apply(this, arguments);
  };
}
export {
  a as default
};
